import React from 'react'
import {
  Twitter,
  GithubIcon,
  Instagram,
  Unsplash,
  Linkedin,
} from 'components/common'
import { Social, Grow } from './styles.js'

export default () => {
  const social = [
    {
      id: 0,
      name: 'Twitter',
      link: 'https://twitter.com/seapatron1',
      icon: Twitter,
      last: false,
    },
    {
      id: 1,
      name: 'Github',
      link: 'https://github.com/serhiosipatron',
      icon: GithubIcon,
      last: false,
    },
    {
      id: 2,
      name: 'Instagram',
      link: 'https://www.instagram.com/sea_patrick',
      icon: Instagram,
      last: false,
    },
    {
      id: 3,
      name: 'Telegram',
      link: 'https://t.me/seapatrick',
      icon: Unsplash,
      last: false,
    },
    {
      id: 4,
      name: 'Linkedin',
      link: 'https://www.linkedin.com/in/sergey-sipatrin-3a3730116',
      icon: Linkedin,
      last: false,
    },
  ]
  return (
    <li>
      {social.map(({ id, name, link, icon, last }) => (
        <Social
          key={id}
          target="_blank"
          rel="noopener noreferrer"
          aria-label={`follow me on ${name}`}
          href={link}
          last={last}
        >
          <Grow as={icon} width="24" height="24" />
        </Social>
      ))}
    </li>
  )
}
